import { useState } from "react";
import {
    Home,
    Target,
    Truck,
    Armchair,
    CreditCard,
    Star,
    PhoneCall,
    Phone,
    Menu,
    X,
    MessageCircle,
} from "lucide-react";
import { PHONE_FIXED, PHONE_FIXED_TEL, WA_MAIN } from "../constants/site";

const NAV_ITEMS = [
    { href: "#inicio", label: "Início", icon: Home, testid: "nav-link-inicio" },
    { href: "#missao", label: "Nossa Missão", icon: Target, testid: "nav-link-missao" },
    { href: "#servicos", label: "Serviços", icon: Truck, testid: "nav-link-servicos" },
    { href: "#confort", label: "Plano Confort", icon: Armchair, testid: "nav-link-confort" },
    { href: "#pagamento", label: "Pagamentos", icon: CreditCard, testid: "nav-link-pagamento" },
    { href: "#satisfacao", label: "Satisfação", icon: Star, testid: "nav-link-satisfacao" },
    { href: "#contato", label: "Contato", icon: PhoneCall, testid: "nav-link-contato" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <nav
            data-testid="main-nav"
            className="sticky top-0 z-50 bg-neutral-900/95 backdrop-blur border-b border-neutral-800"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 h-20 relative flex items-center justify-between gap-4">
                <button
                    type="button"
                    data-testid="nav-mobile-toggle"
                    aria-label="Abrir menu"
                    onClick={() => setOpen((v) => !v)}
                    className="lg:hidden p-2 rounded border border-neutral-600 text-neutral-200"
                >
                    {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                </button>

                <a
                    href="#inicio"
                    data-testid="nav-logo"
                    className="flex items-center group absolute left-1/2 -translate-x-1/2 lg:static lg:translate-x-0"
                >
                    <img
                        src="/assets/logo-tomizo.png"
                        alt="Guincho TMZ — Guincho de Plataforma em Miracatu e Região"
                        className="h-16 lg:h-[4.5rem] w-auto object-contain"
                    />
                </a>

                <div className="hidden lg:flex items-center gap-6 text-xs uppercase tracking-wider font-semibold text-neutral-300">
                    {NAV_ITEMS.slice(1).map((item) => (
                        <a
                            key={item.href}
                            href={item.href}
                            data-testid={item.testid}
                            className="hover:text-[#ff6200] transition-colors flex items-center gap-1.5"
                        >
                            <item.icon className="w-3.5 h-3.5" />
                            {item.label}
                        </a>
                    ))}
                </div>

                <div className="flex items-center gap-3">
                    <a
                        href={PHONE_FIXED_TEL}
                        data-testid="nav-phone-fixed"
                        className="hidden sm:flex flex-col text-right"
                    >
                        <span className="text-[11px] uppercase tracking-wider text-neutral-400 font-medium">
                            Central Miracatu
                        </span>
                        <span className="mono-type text-xs font-bold text-white">{PHONE_FIXED}</span>
                    </a>
                    <a
                        href={WA_MAIN}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-whatsapp-btn"
                        className="bg-[#ff6200] hover:bg-[#e05600] text-white px-4 py-2.5 rounded text-xs font-bold uppercase tracking-wider transition-colors shadow-md flex items-center gap-2"
                    >
                        <Phone className="w-4 h-4" />
                        <span className="hidden xs:inline sm:inline">WhatsApp</span>
                    </a>
                </div>
            </div>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="lg:hidden border-t border-neutral-800 bg-neutral-900 px-4 py-4 space-y-1"
                >
                    {NAV_ITEMS.map((item) => (
                        <a
                            key={item.href}
                            href={item.href}
                            data-testid={`${item.testid}-mobile`}
                            onClick={() => setOpen(false)}
                            className="flex items-center gap-3 px-3 py-2.5 rounded text-sm font-semibold text-neutral-200 hover:bg-[#ff6200]/20 hover:text-[#ff6200] transition-colors"
                        >
                            <item.icon className="w-4 h-4 text-[#ff6200]" />
                            {item.label}
                        </a>
                    ))}
                    <a
                        href={WA_MAIN}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-whatsapp-btn-mobile"
                        className="flex items-center gap-3 px-3 py-2.5 rounded text-sm font-bold text-white bg-[#ff6200]"
                    >
                        <MessageCircle className="w-4 h-4" />
                        Chamar no WhatsApp
                    </a>
                </div>
            )}
        </nav>
    );
};
